/* import __COLOCATED_TEMPLATE__ from './block.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

import type { ContentValue } from '@glint/template';
import type { BvIconSignature } from './../bv-icon/index';
import type { TSize } from 'volta/utils/style-utils';
import type { BvChoiceBlocksInputSignature } from 'volta/components/bv-choice-blocks/input';
import type { IChoiceItem } from '.';

interface BvChoiceBlocksBlockSignature {
  Args: BvChoiceBlocksInputSignature['Args'] & {
    item: IChoiceItem;
    description?: ContentValue;
    icon?: string;
    iconColor?: BvIconSignature['Args']['color'];
    inlineIcon?: boolean;
    size?: TSize;
    title?: string;
  };
  Element: HTMLDivElement;
  Blocks: {
    icon: [IChoiceItem, BvIconSignature['Args']['color'] | undefined];
  };
}

const BvChoiceBlocksBlockComponent = templateOnlyComponent<BvChoiceBlocksBlockSignature>();

export default BvChoiceBlocksBlockComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvChoiceBlocks::Block': typeof BvChoiceBlocksBlockComponent;
    'bv-choice-blocks/block': typeof BvChoiceBlocksBlockComponent;
  }
}
